import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LoadingSpinner from "./components/LoadingSpinner";
import ScrollToTop from "./components/ScrollToTop";
import { RatesProvider } from "./contexts/RatesContext";

// Lazy load pages for better performance
const Home = lazy(() => import("./pages/Home"));
const Gold = lazy(() => import("./pages/Gold"));
const Silver = lazy(() => import("./pages/Silver"));
const SavingsSchemes = lazy(() => import("./pages/SavingsSchemes"));
const OurJourney = lazy(() => import("./pages/OurJourney"));
const Offers = lazy(() => import("./pages/Offers"));
const BookNow = lazy(() => import("./pages/BookNow"));
const Contact = lazy(() => import("./pages/Contact"));
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const CollectionDemo = lazy(() => import("./pages/CollectionDemo"));

// Policy Pages
const CancellationPolicy = lazy(() => import("./pages/CancellationPolicy"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const ReturnPolicy = lazy(() => import("./pages/ReturnPolicy"));
const ShippingPolicy = lazy(() => import("./pages/ShippingPolicy"));

function App() {
  return (
    <RatesProvider>
      <ScrollToTop />
      <div className="App min-h-screen flex flex-col">
        <Helmet>
          <title>Akila Jewellers - Where Tradition Meets Elegance</title>
          <meta
            name="description"
            content="Premium gold and silver jewellery, savings schemes, and exclusive offers from Akila Jewellers."
          />
          <meta
            name="keywords"
            content="jewellery, gold, silver, savings scheme, akila jewellers, traditional jewellery, premium jewellery"
          />
          <meta name="author" content="Akila Jewellers" />
          <link rel="canonical" href="https://akilajewellers.com/" />
        </Helmet>

        <Header />

        <main className="flex-grow">
          <Suspense fallback={<LoadingSpinner />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/gold" element={<Gold />} />
              <Route path="/silver" element={<Silver />} />
              <Route path="/savings-schemes" element={<SavingsSchemes />} />
              <Route path="/our-journey" element={<OurJourney />} />
              <Route path="/offers" element={<Offers />} />
              <Route path="/book-now" element={<BookNow />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/collection-demo" element={<CollectionDemo />} />

              {/* Policy Pages */}
              <Route
                path="/cancellation-policy"
                element={<CancellationPolicy />}
              />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/return-policy" element={<ReturnPolicy />} />
              <Route path="/shipping-policy" element={<ShippingPolicy />} />
            </Routes>
          </Suspense>
        </main>

        <Footer />
      </div>
    </RatesProvider>
  );
}

export default App;
